import {
  Box,
  Button,
  CollectionPreferences,
  Header,
  Pagination,
  Table,
  SpaceBetween,
} from '@amzn/awsui-components-react';
import React from 'react';

interface ShowAuditTrailProps {
  auditEventsList: any[];
  isGetAuditEventsLoading: boolean;
  getAuditEventsError: string;
  currentPage: number;
  totalPages: number;
  handlePageChange: (page: number) => void;
  preferences: { pageSize: number };
  setPreferences: React.Dispatch<React.SetStateAction<{ pageSize: number }>>;
  getAuditEventChanges: (timestamp: string) => void;
  setModalContext: React.Dispatch<
    React.SetStateAction<{
      lastUpdatedBy: string;
      lastUpdatedDateTime: string;
    } | null>
  >;
  CONSTANTS: any;
}

export const ShowAuditTrail = ({
  auditEventsList,
  isGetAuditEventsLoading,
  getAuditEventsError,
  currentPage,
  totalPages,
  handlePageChange,
  preferences,
  setPreferences,
  getAuditEventChanges,
  setModalContext,
  CONSTANTS,
}: ShowAuditTrailProps) => {
  return (
    <div>
      <Table
        columnDefinitions={[
          {
            id: 'timestamp',
            header: 'Timestamp',
            cell: (item) => (item.lastUpdatedDateTime ? new Date(item.lastUpdatedDateTime).toLocaleString() : '-'),
          },
          {
            id: 'eventType',
            header: 'Event Type',
            cell: (item) => item.eventType || '-',
          },
          {
            id: 'user',
            header: 'User',
            cell: (item) => item.updatedBy || '-',
          },
          {
            id: 'changes',
            header: 'Changes',
            cell: (item) => {
              if (Object.values(CONSTANTS.VALID_CHANGE_STATES).includes(item.eventType)) {
                return (
                  <Button
                    variant="link"
                    disabled={isGetAuditEventsLoading}
                    onClick={() => {
                      setModalContext({
                        lastUpdatedBy: item.updatedBy || '—',
                        lastUpdatedDateTime: item.lastUpdatedDateTime!,
                      });
                      getAuditEventChanges(item.lastUpdatedDateTime!);
                    }}
                  >
                    View Changes
                  </Button>
                );
              }
              return null;
            },
          },
        ]}
        items={auditEventsList}
        loading={isGetAuditEventsLoading}
        loadingText="Loading audit events..."
        trackBy="timestamp"
        empty={
          <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
            <SpaceBetween size="m">
              <b>{getAuditEventsError}</b>
            </SpaceBetween>
          </Box>
        }
        header={<Header>Audit Events</Header>}
        pagination={
          <Pagination
            currentPageIndex={currentPage}
            pagesCount={totalPages}
            onChange={({ detail }) => handlePageChange(detail.currentPageIndex)}
            openEnd={false}
          />
        }
        preferences={
          <CollectionPreferences
            onConfirm={({ detail }) => setPreferences((prev) => ({ ...prev, pageSize: detail.pageSize || 50 }))}
            title="Audit Trail Preferences"
            cancelLabel="Cancel"
            confirmLabel="Confirm"
            preferences={preferences}
            pageSizePreference={{
              title: 'Page Size',
              options: [
                { value: 10, label: '10 audit events' },
                { value: 25, label: '25 audit events' },
                { value: 50, label: '50 audit events' },
              ],
            }}
          />
        }
      />
    </div>
  );
};
